/*
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2023-03-28 15:43:28
 * @LastEditors: fangzhi fangzhi@vivo.com
 * @LastEditTime: 2023-03-28 16:25:46
 * @FilePath: /h5/src/utils/aria.js
 * @Description: 无障碍适配相关方法
 */

/**
 * 隐藏同级元素使屏幕阅读器忽略元素，进而控制焦点不会移动到外部去
 * @param {*} id 元素id
 * @param {*} flag 布尔值，表示隐藏或者不隐藏
 */
export function hideSiblingEls(id, flag) {
  let hiddenDom = document.getElementById(id)?.parentElement.children
  if (hiddenDom && hiddenDom.length > 1) {
    if (flag) {
      for (let index = 0; index < hiddenDom.length; index++) {
        const element = hiddenDom[index]
        if (element.id != id) {
          element.setAttribute('aria-hidden', 'true')
        }
      }
    } else {
      for (let index = 0; index < hiddenDom.length; index++) {
        const element = hiddenDom[index]
        if (element.id != id) {
          element.removeAttribute('aria-hidden')
        }
      }
    }
  }
}
/**
 * 设置元素更新时是否需要实时播报
 * @param {*} ids 需要更新的元素id列表
 * @param {*} value aria-live的值，off, polite, assertive,rude。默认为off, 表示不宣布更新；polite表示只有用户闲时宣布；assertive表示尽快对用户宣布；rude表示即时提醒用户，必要的时候甚至中断用户。
 */
export function setAriaLiveByIds(ids, value) {
  if (Array.isArray(ids)) {
    ids.forEach(element => {
      document.getElementById(element)?.setAttribute('aria-live', value)
    })
  }
}
